import React from 'react';

function DropDown(props) {
    const handleClick = (event) => {
        if (!event) {
            return;
        }
        event.preventDefault();
        event.stopPropagation();

        if (props.onClick) {
            props.onClick(props.name);
        }
    }
    let type = props.checkable == false ? 'select' : 'multiselect';
    let className = type;
    if (props.active) {
        className += ` ${type}--opened`;
    }
    let containerClassName = `${type}__cont`
    const options = props.options || [];
    let style;
    if (props.backgroundColor) {
        style = { backgroundColor: props.backgroundColor };
    }
    return (
        <React.Fragment>
            {
                props.active &&
                <div className={`${type}__background`} onClick={handleClick} />
            }
            <div className={containerClassName}>
                <div className={className} style={style} onClick={handleClick}>
                    <div className={`${type}__label`}>{props.label}</div>
                    <div className={`${type}__options`} style={style}>
                        {
                            props.active &&
                            options.map((d) => <Option key={d.id} {...d} checkable={props.checkable} name={props.name} type={type} onClick={props.onSelect} />)
                        }
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}

function Option(props) {
    const handleClick = (event) => {
        if (!event || !event.currentTarget) {
            return;
        }
        event.preventDefault();
        event.stopPropagation();

        if (props.onClick) {
            props.onClick(props.name, props.id);
        }
    }
    return (
        <div className={`${props.type}__option`} onClick={handleClick}>
            {
                props.checkable != false &&
                <span className="multiselect__option__check">
                    {
                        props.checked &&
                        <input defaultChecked={true} type="checkbox" />
                    }
                    {
                        !props.checked &&
                        <input type="checkbox" />
                    }
                </span>
            }
            <span className={`${props.type}__option__label`}>{props.display}</span>
        </div>
    );
}

export {
    DropDown,
    Option
};